export default __webpack_public_path__ + "static/media/la_capelle10.7600428f.jpg";